import {createLogger} from '@modifi/utilities'

export default createLogger('janus')
